import { Timeline, TimelineItemProps } from 'antd'
import ScheduleIcon from '@mui/icons-material/Schedule';
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { Customer } from '../../model/Customer'
import dayjs from 'dayjs'
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { PaymentSummaryResponseDTO } from '../../model/ResponsesDTO';
import { ProviderValue, useAxios } from '../../config/axios-config';
import { PageLoader } from '../util/PageLoader';
import { ErrorPage } from '../error/ErrorPage';


export const HistoryPopover : React.FC<{customer : Customer, showHistory : boolean, setShowHistory : Dispatch<SetStateAction<boolean>>
}> = (props) => {

  const axiosInstance = useAxios() as ProviderValue
    const {customer, showHistory, setShowHistory} = props
    const [historyItems, setHistoryItems] = useState<TimelineItemProps[]>([])
    const [isLoaded, setIsLoaded] = useState<boolean>(false)
    const [isError, setIsError] = useState<boolean>(false)
    const controller = new AbortController();
    const signal = controller.signal

    useEffect(() => {
      if (showHistory) {
        handleHistoryItems()
      }
    // eslint-disable-next-line 
    },[showHistory])
      
    const handleHistoryItems = async () => {
      if (customer.paymentSummary?.paymentsummaryid !== undefined) {
        await axiosInstance.get<PaymentSummaryResponseDTO>(`/paymentsummaries/secure/paymentsummary/${customer.paymentSummary?.paymentsummaryid}`, 
          {signal}).then((response) => {
            
            let items : any[] = response.data.paymentSummary.paymentHistories
              
              .map(historyElement => (
              {
                label: historyElement.paymenthistorydate.toString(),
                children: historyElement.description,
                color: '#55B1B4',
                order: historyElement.createTime
              }
            ))
            let billingItems : any[] = customer.billings!
            .filter(billing => billing.datePeriod >= customer.activeStart)
            .map(billing => {
              let date = dayjs(billing.datePeriod).month() === dayjs().month() ? dayjs().startOf('day')
                  : dayjs(billing.datePeriod).endOf('month')
                return ({
                  label: date.format('YYYY-MM-DD'),
                  children: `Należność (na chwilę obecną) -${billing.billingTotalAmount} zł 
                  (Opłata za posiłki w miesiącu ${dayjs(billing.datePeriod).format("MMMM YYYY")})`,
                  dot: <ScheduleIcon fontSize='small'/>,
                  color: '#55B1B4',
                  order: date.unix()*1000
                })
              })
              if (items !== undefined && billingItems !== undefined) {
                setHistoryItems([...billingItems, ...items].sort((a,b) => dayjs(b.order! as number)
                    .diff(dayjs(a.order! as number))) as TimelineItemProps[])
              } else {
                setHistoryItems([])
              }
            setIsLoaded(true) 
          }).catch((e) => {
              setIsLoaded(true) 
              setIsError(true)
              console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
          })
      } else {
        setIsLoaded(true) 
      }
    }

    return (
        <Dialog fullWidth onClose={() => setShowHistory(false)} open={showHistory}>
            <DialogTitle id="dialog-title">
                {"Historia płatności rodzica"}
            </DialogTitle>
            <DialogContent>
              {!isLoaded ?
                isError ?
                  <ErrorPage /> 
                  :
                  <PageLoader />
                :
                <Timeline className="mt-3 mb-0" mode='left' items={historyItems}/>
              }
                
            </DialogContent>
            <DialogActions>
                <button className='button-65' onClick={() => setShowHistory(false)}>
                    Zamknij
                </button>
            </DialogActions>
        </Dialog>
    )
}